import SkeletonBox from '@/components/atoms/SkeletonBox/SkeletonBox';

import styles from './ActiveFishGroupSection.module.scss';

const FIELDS = [
    { key: 'name', height: 'var(--control-height)' },
    { key: 'fishCount', height: 'var(--control-height)' },
    { key: 'reason', height: 84 },
];

/** The fish-group card's form while its group loads: the same fields, so nothing jumps. */
export function ActiveFishGroupSkeleton() {
    return (
        <div className={styles.skeleton} aria-busy="true">
            <SkeletonBox width="80%" height={14} />
            {FIELDS.map((field) => (
                <div key={field.key} className={styles.skeletonField}>
                    <SkeletonBox width="40%" height={14} />
                    <SkeletonBox width="100%" height={field.height} />
                </div>
            ))}
            <SkeletonBox width={88} height="var(--control-height)" />
        </div>
    );
}
